<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/proposal-software-for-freelancers.mjs";
</script>
